module.exports = __webpack_public_path__ + "img/canyon_grey_ba_list.b65ae190.jpg";